import { generateRGBPalette } from '../helpers'
import {
  BAR_CHART_COLOR_DARK,
  BAR_CHART_SELECTED_COLOR_DARK,
  BAR_CHART_SELECTED_SHADOW_COLOR_DARK,
  PIE_CHART_PALETTE_DARK,
} from '../const'

export default {
  color: generateRGBPalette(
    PIE_CHART_PALETTE_DARK[0],
    PIE_CHART_PALETTE_DARK[1],
    8,
  ),
  textStyle: {},
  title: {
    textStyle: {
      color: '#6b7280',
    },
    subtextStyle: {
      color: '#6b7280',
    },
  },
  label: {
    color: '#BCBCBC',
    rich: {
      value: {
        fontSize: 10,
        color: '#8A929F',
      },
    },
  },
  legend: {
    textStyle: {
      color: '#8A929F',
    },
  },
  tooltip: {
    backgroundColor: '#1f2937',
    textStyle: {
      color: '#8A929F',
    },
  },
  bar: {
    color: BAR_CHART_COLOR_DARK,
    select: {
      itemStyle: {
        color: BAR_CHART_SELECTED_COLOR_DARK,
        borderWidth: 0,
        shadowBlur: 8,
        shadowColor: BAR_CHART_SELECTED_SHADOW_COLOR_DARK,
        shadowOffsetY: 2,
      },
    },
  },
  pie: {
    itemStyle: {
      borderWidth: 1,
      borderColor: '#1f2937',
    },
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#BCBCBC',
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: '#8A929F',
      },
    },
    axisLabel: {
      show: true,
      color: '#BCBCBC',
    },
  },
  valueAxis: {
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: true,
      color: '#8A929F',
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#8A929F', '#8A929F'],
      },
    },
  },
}
